module.exports.oberon = {
  vi: {
    title: 'Oberon trong Avalon: năng lực và chiến thuật',
    description:
      'Merlin có thấy Oberon trong Avalon không? Có. Tìm hiểu vì sao Oberon không biết các người chơi Ác khác, điểm khác Mordred và cách biến thể Bóng ma hoạt động.',
    keywords: ['Oberon', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Oberon em Avalon: habilidades e estratégia',
    description:
      'Merlin vê Oberon em Avalon? Sim. Saiba por que Oberon não conhece os outros jogadores do mal, como difere de Mordred e o que muda na variante Wraith.',
    keywords: ['Oberon', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Oberon in Avalon: Abilities & Strategy',
    description:
      'Does Merlin see Oberon in Avalon? Yes. Learn why Oberon does not know the other evil players, how he differs from Mordred, and how the Wraith variant works.',
    keywords: ['Oberon', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Оберон в Авалоне: способности и стратегия',
    description:
      'Видит ли Мерлин Оберона в Авалоне? Да. Разберите, почему Оберон не знает других злых, чем отличается от Мордреда и как работает вариант Призрак.',
    keywords: ['Оберон', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆奧伯倫：角色能力與玩法策略',
    description: '阿瓦隆梅林能看到奧伯倫嗎？能。了解奧伯倫為什麼不認識其他壞人、與莫德雷德的區別，以及幽靈變體的能力。',
    keywords: ['奧伯倫', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆奥伯伦：角色能力与玩法策略',
    description: '阿瓦隆梅林能看到奥伯伦吗？能。了解奥伯伦为什么不认识其他坏人、与莫德雷德的区别，以及幽灵变体的能力。',
    keywords: ['奥伯伦', '角色', '规则', '建议'],
  },
  es: {
    title: 'Oberón en Avalon: habilidades y estrategia',
    description:
      '¿Merlín ve a Oberon en Avalon? Sí. Descubre por qué Oberon no conoce a los demás malvados, su diferencia con Mordred y la variante Wraith.',
    keywords: ['Oberón', 'Rol', 'Reglas', 'Consejos'],
  },
};
